import axios from 'axios';
import Vue from 'vue'

export default {

    getMessage (page, pageSize, start,end,customerId) {
        return axios.get('/api/message/list', { params: { page: page, pageSize: pageSize, start: start , end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    createMessage (message) {
        return axios.post('/api/message/create', message)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    markMessageViewed (page, pageSize, start,end,customerId, messageId) {
        return axios.get('/api/message/viewed', { params: { page: page, pageSize: pageSize, start: start , end:end,customerId:customerId, id:messageId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteMessage (page, pageSize, start,end,customerId, messageId) {
        return axios.get('/api/message/delete', { params: { page: page, pageSize: pageSize, start: start , end:end,customerId:customerId, id:messageId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}

